import { type UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UpdateClient } from '@/schemas/API/PUT/client/request';
import type { ClientDetailed } from '@/schemas/API/GET/client/response';
import { clientDetailToUpdateClient } from '@/schemas/converters/clientSchemasConverter';
import { isEmptyForm } from '@/utils/functions';

/**
 * Custom hook that synchronizes a client object of type ClientDetailed with a form.
 * It sets the initial form values based on the client object,
 * and updates the form values whenever the client object changes.
 *
 * @param client - The client object to synchronize with the form.
 * @param clientForm - The form object returned by the `useForm` hook.
 */
const useSyncFormWithClient = (
  client: ClientDetailed | undefined,
  clientForm: UseFormReturnType<UpdateClient>
) => {
  useEffect(() => {
    if (!client) return;
    const clientUpdate = clientDetailToUpdateClient(client);
    clientForm.setInitialValues(clientUpdate);
    if (isEmptyForm(clientForm)) clientForm.reset();
  }, [client]);
};

export default useSyncFormWithClient;
